import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";

// STATE AND STORE
// LIBS
import API from "../../api";
import { fioFromObject } from "../../lib/helpers/strings";
import { getDocsType, getDocsNumberFormatted } from "../../lib/helpers/users";

// UI
import { TelPhones } from "@malond/ui-phone";
import { HeaderPage, Table, Pagination, Badge } from "../../ui";

class DepositorsListPage extends Component {
  state = {
    titleHeader: "Залогодатели",
    loading: true,
    depositors: {
      list: [],
      meta: {
        page: 0,
        pages: 0,
        count: 0,
        perPage: 0,
        fromRecord: 0,
        toRecord: 0
      }
    },
    query: {
      page: 0
    },
    search: false
  };

  async componentDidMount() {
    const { page, number } = qs.parse(window.location.search);
    const searchParams = {};
    // let search = false;

    if (page > 0) {
      searchParams.page = page;
    }
    if (number > 0) {
      // search = true;
      searchParams.number = number;
      // form.number.value = number;
    }

    const { data, meta } = await API.depositors.getList(searchParams, {
      full: true
    });

    this.setState({
      loading: false,
      depositors: {
        list: data,
        meta
      },
      // form,
      // search,
      query: {
        page: page || 0
      }
      // buttons: {
      //   filterDisabled: false
      // }
    });
  }

  onChangedPagination = async page => {
    // const { number } = qs.parse(window.location.search);
    const searchParams = { page };
    const queryParams = { page };

    this.setState({
      loading: true
    });

    // if (number > 0) {
    //   queryParams.number = number;
    // }

    this.props.history.push({
      pathname: "/depositors",
      search: qs.stringify(queryParams, true)
    });

    // this.setState({
    //   buttons: {
    //     filterDisabled: true
    //   }
    // });

    const { data, meta } = await API.depositors.getList(
      { ...searchParams },
      { full: true }
    );

    this.setState({
      loading: false,
      depositors: {
        list: data,
        meta
      },
      query: {
        page
      }
      // buttons: {
      //   filterDisabled: false
      // }
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.depositors.meta.fromRecord + i
      },
      {
        title: "ФИО",
        suffix: "залогодателя",
        render: ({ item }) => {
          return (
            <Link to={`/depositors/${item._id}`}>{fioFromObject(item)}</Link>
          );
        }
      },
      {
        title: "Номер",
        prefix: "Используемый",
        suffix: "документа при поиске",
        text: "right",
        render: ({ item }) => getDocsNumberFormatted(item.ud_number)
      },
      {
        title: "Телефон",
        text: "right",
        render: ({ item }) => {
          return <TelPhones className="size-small">{item.tel}</TelPhones>;
        }
      },
      {
        title: "Тип",
        prefix: "Используемый",
        suffix: "документа при залоге",
        render: ({ item }) => {
          let docsTypeText = getDocsType(item.docs);
          if (!item.docs || !item.docs.length) {
            return (
              <Badge size="small" theme="error">
                {docsTypeText}
              </Badge>
            );
          } else {
            return docsTypeText;
          }
        }
      },
      {
        title: "Номер",
        prefix: "Используемый",
        suffix: "документа при залоге",
        text: "right",
        render: ({ item }) => getDocsNumberFormatted(item.docs_number)
      }
    ];
  };

  render() {
    const { depositors } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          count={depositors.meta.count}
        />

        <Table
          columns={this.getTableColumns()}
          data={depositors.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={"/depositors"}
          linkPagesQuery={false}
          count={depositors.meta.count}
          page={depositors.meta.page}
          pages={depositors.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(DepositorsListPage));
